// extracted by mini-css-extract-plugin
module.exports = {"accountOverview":"styles_accountOverview__9Ub59","titleSection":"styles_titleSection__CpZ8H","updateButton":"styles_updateButton__FUYtX","formInput":"styles_formInput__afdrX"};